module.exports = __webpack_public_path__ + "static/media/xenon-narrow.814037a6.png";